import validator from "validator";

const validateForm = (formData) => {
  const errors = {};

  if (validator.isEmpty(formData.name)) {
    errors.name = "Name is required";
  }

  if (validator.isEmpty(formData.subject)) {
    errors.subject = "Subject is required";
  }

  if (validator.isEmpty(formData.phoneNumber)) {
    errors.phoneNumber = "Phone number is required";
  } else if (!validator.isNumeric(formData.phoneNumber)) {
    errors.phoneNumber = "Phone number must be numeric";
  } else if (!validator.isLength(formData.phoneNumber, { min: 10, max: 10 })) {
    errors.phoneNumber = "Phone number must be 10 digits";
  }

  if (validator.isEmpty(formData.email)) {
    errors.email = "Email is required";
  } else if (!validator.isEmail(formData.email)) {
    errors.email = "Email is invalid";
  }

  if (validator.isEmpty(formData.issueType)) {
    errors.issueType = "Issue Type is required";
  }

  if (
    formData.issueType === "Other" &&
    validator.isEmpty(formData.otherIssue)
  ) {
    errors.otherIssue = "Please specify the issue";
  }

  if (validator.isEmpty(formData.priorityLevel)) {
    errors.priorityLevel = "Priority Level is required";
  }

  if (validator.isEmpty(formData.description)) {
    errors.description = "Description is required";
  }

  return errors;
};

export default validateForm;
